import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { AcquirersContractsTable } from "./AcquirersContractsTable";

export const AcquirersContractsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <AcquirersContractsTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
